import * as MKPlayerSDK from "@mediakind/mkplayer";
import React from "react";
import "./mkplayer-ui.css";
import { decryptForLocalUsage } from "./common_utils";

export function Mediakind(props) {
    const key = decryptForLocalUsage(localStorage.getItem("v_ky"));
    const token = decryptForLocalUsage(localStorage.getItem("v_tk"));

    const vContainerRef = React.useRef(null);
    const playerRef = React.useRef(null);

    const playerConfig = React.useMemo(() => ({
        key: key,
        ui: true,
        playback: {
            muted: true,
            autoplay: false,
            preferredTech: [
                { player: "html5", streaming: "hls" },
                { player: "native", streaming: "hls" }
            ]
        }
    }), [key]);

    const sourceConfig = React.useMemo(() => ({
        hls: props.url,
        drm: {
            clearkey: {
                LA_URL: "HLS_AES",
                headers: {
                    Authorization: "Bearer=" + token,
                    "Content-Type": "application/json"
                }
            }
        }
    }), [props.url, token]);

    const load = React.useCallback(async () => {
        if (!MKPlayerSDK) {
            console.log("::: MKPlayer SDK not initiated yet :::");
            return;
        }

        if (playerRef.current?.unload) {
            await playerRef.current.unload();
        }

        playerRef.current = new MKPlayerSDK.MKPlayer(
            vContainerRef.current,
            playerConfig
        );

        await playerRef.current.load(sourceConfig);

        if (!playerConfig.playback.autoplay) {
            playerRef.current.play();
        }
    }, [playerConfig, sourceConfig]);

    React.useEffect(() => {
        load();

        return () => {
            if (playerRef.current?.destroy) {
                playerRef.current.destroy();
            }
            playerRef.current = null;
        };
    }, [load]);

    return (
        <div className="container">
            <div
                ref={vContainerRef}
                className="video-container"
                id="video-container"
            />
        </div>
    );
}
